import CreditNoteList from './List';
import { CreditNoteShow } from './Form';
import CreditNoteCreate from './CreditNoteCreate';

export default {
  list: CreditNoteList,
  create: CreditNoteCreate,
  show: CreditNoteShow,
};
